<template>
	<el-menu
		:default-active="mainMenuActiveIndex"
		class="el-menu-demo"
		mode="horizontal"
		@select="handleSelect"
		background-color="#545c64"
		text-color="#fff"
		active-text-color="#ffd04b"
		v-if="hasMenuBar"
	>
		<li tabindex="0" class="el-menu-item menu-logo">UNIK 管理后台</li>
		<el-menu-item @click="handleLogout" class="float-right" index="logout">退出</el-menu-item>
		<el-menu-item class="float-right" index="adminuser">{{userInfo.userName}}</el-menu-item>
	</el-menu>
</template>
<script type="text/javascript">
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	name: "Menu-bar",
	data() {
		return {};
	},

	computed: {
		...mapState(["mainMenuActiveIndex", "hasMenuBar", "userInfo"]),
	},
	created() {},
	mounted() {},

	methods: {
		...mapMutations(["doLogout"]),
		handleSelect(key, keyPath) {},
		handleLogout() {
			this.$axios
				.post(`/admin/logout/`)
				.then(json => {
					this.doLogout();
					this.$router.push({
						name: "Login",
					});
				})
				.catch(json => {
					console.error(json);
				});
		},
	},
	components: {},
};
</script>
